// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primaryLight":"#ABEAFF","secondaryLight":"#7FE7AB","app-background":"_1Vi8n9p3kDKjL0P-dMnOJO","bg-underlayer":"_1stA16gAUCGVSCladEwuYH","bg-figure-1":"_2X7I65tV4KoOn6sLMDTg1x","bg-figure-2":"_2UttAuohBUBu94qGTtxMjx","bg-figure-3":"_2hn041Wtafajwe24IWZtCE","bg-congrats":"_38PdMwTAdNJ9El7KPSu3cJ","primary":"_1OdvzP8nxLYMH9jycEZ-te","secondary":"DmCGzhH_bpsPVNRmmsXOy","congrats":"bcEviOZgHV0QM0PhBSFkV","grey":"_3mxSWxSvgHSgGfU2JPPDnZ","none":"AS--xog6VfK5-RFZuIibN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Background/Background.mod.css
// module id = 996
// module chunks = 0